import BaseXMLGenerator from './xlsx-tableexport-generator.js';

var XMLGenerator = new BaseXMLGenerator();
XMLGenerator.baseGenerate = XMLGenerator.generate
XMLGenerator.generate = function (vm, datas) {
    var rows = []
    for (var data of datas) {
        var row = []
        row.push(data.Title)
        row.push(data.Content)
        rows.push(row)
    }
    let headerList = ['標題', '內容']
    return this.baseGenerate(rows, headerList)
}

export default XMLGenerator;